import { render, staticRenderFns } from "./SalesPhysicalListTop.vue?vue&type=template&id=5a95a1c8&scoped=true&"
import script from "./SalesPhysicalListTop.vue?vue&type=script&lang=js&"
export * from "./SalesPhysicalListTop.vue?vue&type=script&lang=js&"
import style0 from "./SalesPhysicalListTop.vue?vue&type=style&index=0&id=5a95a1c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a95a1c8",
  null
  
)

export default component.exports